module.exports = __webpack_public_path__ + "static/media/konop1.1be9c8e5.jpg";